import { Box, Dialog, DialogContent, Grid2, Typography } from '@mui/material'
import KPIFilters from '../components/kpi_reporting/KPIFilters'
import KPIDetails from '../components/kpi_reporting/KPIDetails'
import { useEffect, useRef, useState } from 'react';
import { KPIAdditionalFiltersType, KPIContext, KPIContextState } from '../contexts/kpiContext';
import { useDispatch, useSelector } from 'react-redux';
import { getKpiCount, selectIfKpiCountLoading, selectIfKpiInsightLoading, selectKpiFiltersApplied } from '../store/slices/kpiReportingSlice';
import { AppDispatch } from '../store/store';
import AIRepsonseLoadingProgress from '../components/shared/AIRepsonseLoadingProgress';
import DarkAdnocLoadingProgress from '../components/shared/DarkAdnocLoadingProgress';
import KPIPyramidNew from '../components/kpi_reporting/KPIPyramidNew';

function KPIReporting() {

    const dispatch = useDispatch<AppDispatch>();

    const isKpiCountLoading = useSelector(selectIfKpiCountLoading);
    const isKpiInsightLoading = useSelector(selectIfKpiInsightLoading);
    const showProgressIndicator = isKpiCountLoading === true || isKpiInsightLoading === true;

    const pyramidRef = useRef<HTMLDivElement | null>(null);
    const kpiDetailsRef = useRef<HTMLDivElement | null>(null);

    const filtersAppliedAlready = useSelector(selectKpiFiltersApplied);

    const [filterState, setFilterState] = useState<KPIContextState>({
        showKpiDetails: false,
        filters: { ...filtersAppliedAlready },
    })

    const updateSelectedKpiName = (value: string) => setFilterState((prev) => ({
        ...prev,
        filters: {
            ...prev.filters,
            selectedKpiName: value
        }
    }))
    const toggleShowDetails = (value: boolean) => setFilterState((prev) => ({ ...prev, showKpiDetails: value }));
    const updateFilters = (values: KPIAdditionalFiltersType) => {
        setFilterState(prev => ({ ...prev, filters: { ...values } }))
    };

    useEffect(() => {
        if (isKpiCountLoading === null)
            dispatch(getKpiCount({ ...filtersAppliedAlready }))
    }, [dispatch, filtersAppliedAlready, isKpiCountLoading])

    useEffect(() => {
        if (pyramidRef.current && kpiDetailsRef.current) {
            if (filterState.showKpiDetails) {
                pyramidRef.current.style.display = 'none';
                kpiDetailsRef.current.style.display = 'flex';
            } else {
                pyramidRef.current.style.display = 'flex';
                kpiDetailsRef.current.style.display = 'none';
            }
        }
    }, [filterState.showKpiDetails])

    return (
        <KPIContext.Provider value={{
            state: filterState, updateSelectedKpiName, toggleShowDetails, updateFilters
        }} >
            <Dialog open={showProgressIndicator} sx={{
                backgroundColor: 'rgba(255,255,255,15%)',
                backdropFilter: 'blur(2px)',
                '& .MuiPaper-root': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none'
                }
            }}>
                <DialogContent sx={{ background: 'transparent' }}>
                    {isKpiCountLoading && !isKpiInsightLoading && <DarkAdnocLoadingProgress size='xlarge'></DarkAdnocLoadingProgress>}
                    {isKpiInsightLoading && <AIRepsonseLoadingProgress textColor="var(--text-light)"></AIRepsonseLoadingProgress>}
                </DialogContent>
            </Dialog>
            {!filterState.showKpiDetails && <Grid2 container sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                gap: 2,
                position: 'relative',
                top: 'max(64px, 6vh)',
                zIndex: 1,
                boxSizing: 'border-box',
                paddingX: 2,
                paddingTop: 5,
            }}>
                <Grid2 sx={{
                    display: 'grid',
                    gridTemplateColumns: '17.5% 50%',
                    boxSizing: 'border-box',
                }}>
                    <Box sx={{
                        display: 'grid',
                        width: '100%',
                        boxSizing: 'border-box',
                        borderLeft: '0.5vw solid #41D9E1',
                        paddingLeft: 1,
                        rowGap: 1,
                        height: 'max-content',
                        background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) -7.34%, rgba(255, 255, 255, 0.52) 50%)',
                    }}>
                        <Typography variant='h4'>
                            KPI Reporting
                        </Typography>
                        <Typography variant='h6' fontWeight={500}>
                            Select Tier 3 KPI for details
                        </Typography>
                    </Box>
                    <KPIFilters></KPIFilters>
                </Grid2>
                <Grid2 size={{xs: 8}} sx={{
                    height: '50vh',
                    marginX: 1,
                }}>
                    <KPIPyramidNew></KPIPyramidNew>
                </Grid2>
            </Grid2>}
            {filterState.showKpiDetails && <Grid2 sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                gap: 2,
                position: 'relative',
                top: 'max(64px, 6vh)',
                zIndex: 2,
                boxSizing: 'border-box',
                padding: 2,
                paddingTop: 5,
            }}>
                <KPIDetails></KPIDetails>
            </Grid2>}
        </KPIContext.Provider>
    )
}

export default KPIReporting